import { ROLES } from '../../../../Permission'

export const VendorsListMenuItems = [
  {
    label: 'Upgrade to Full Access',
    key: 'upgrade'
  },
  {
    label: 'Add to my vendors',
    key: 'add_to_my_vendors'
  }
]

export const rolesForUpgrade: string[] = [
  ROLES.COMMUNITY_PRESIDENT,
  ROLES.VICE_PRESIDENT,
  ROLES.CONTRACT_STEWARD,
  ROLES.ANALYST,
  ROLES.COMMONS_VICE_PRESIDENT,
  ROLES.COMMONS_ANALYST,
  ROLES.COMMONS_CONTRACT_STEWARD,
  ROLES.COMMONS_CLINICAL_COORDINATOR
]
